// extracted by mini-css-extract-plugin
export default {"group":"ValidatedDropdown_group__Zdrdk","label":"ValidatedDropdown_label__6KG8R"};